const cartEn = {
  title: 'My Shopping Bag',
  clearAll: 'Clear All',
  itemsInBag: (n) => `${n} items in your bag`,
  sectionCartItems: 'Items in your bag',
  continueShopping: 'Continue Shopping',
  orderSummary: 'Order Summary',
  subtotal: 'Subtotal',
  delivery: 'Delivery Charge',
  free: 'Free',
  discount: 'Discount',
  total: 'Total',
  couponPlaceholder: 'Enter coupon code',
  applyCoupon: 'Apply Coupon',
  proceedCheckout: 'Proceed to Checkout',
  trust: {
    securePayment: '100% Secure Payment',
    fastDelivery: 'Fast Delivery',
    cod: 'Cash on Delivery'
  },
  empty: {
    title: 'Your cart is empty',
    subtitle: 'It looks like you have not added any items yet.\nBrowse our beautiful products and start shopping!',
    cta: 'Start Shopping'
  },
  item: {
    inStock: 'In Stock',
    removed: 'Item removed from cart'
  },
  cleared: 'All items removed from cart'
};

export default cartEn;


